import { useEffect, useState } from "react";
import { Bot } from "lucide-react";
import api from "@/lib/api";

const COLORS = { openai: "#10a37f", claude: "#d97757" };
const FEATURE_LABEL = { prompt: "Prompts Studio", soundscape: "Soundscapes Gaming", metadata: "Métadonnées de piste" };

// Billing card: weekly ChatGPT vs Claude picks + per-feature split.
export default function ModelStatsCard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/ai/preference/stats").then(({ data }) => setStats(data)).catch(() => {}); }, []);
  if (!stats) return null;
  const max = Math.max(1, ...stats.weeks.map((w) => w.openai + w.claude));
  return (
    <div className="rounded-2xl border border-border bg-card p-6" data-testid="model-stats-card">
      <div className="flex items-center justify-between mb-1">
        <h3 className="font-display text-lg font-bold flex items-center gap-2"><Bot size={18} className="text-primary" /> Modèles IA choisis</h3>
        <span className="text-xs font-mono text-muted-foreground" data-testid="model-stats-total">{stats.total} choix · 8 semaines</span>
      </div>
      <p className="text-xs text-muted-foreground mb-4">Quel modèle vous appliquez le plus, semaine par semaine et par fonctionnalité.</p>
      <div className="flex items-center gap-4 text-[10px] font-mono mb-3">
        {Object.entries(stats.labels).map(([k, v]) => (
          <span key={k} className="inline-flex items-center gap-1.5"><span className="w-2.5 h-2.5 rounded-sm" style={{ background: COLORS[k] }} /> {v}</span>
        ))}
      </div>
      <div className="flex items-end gap-2 h-28" data-testid="model-stats-weeks">
        {stats.weeks.map((w) => {
          const tot = w.openai + w.claude;
          return (
            <div key={w.week} className="flex-1 flex flex-col items-center gap-1 h-full justify-end" title={`${w.week} · ChatGPT ${w.openai} · Claude ${w.claude}`}>
              <div className="w-full flex flex-col justify-end rounded-sm overflow-hidden bg-muted/40" style={{ height: "88px" }}>
                <div className="w-full flex flex-col justify-end" style={{ height: `${(tot / max) * 100}%` }}>
                  {w.claude > 0 && <div style={{ flex: w.claude, background: COLORS.claude }} />}
                  {w.openai > 0 && <div style={{ flex: w.openai, background: COLORS.openai }} />}
                </div>
              </div>
              <span className="text-[9px] font-mono text-muted-foreground">{w.week.slice(5)}</span>
            </div>
          );
        })}
      </div>
      <div className="mt-5 space-y-2" data-testid="model-stats-features">
        {Object.keys(FEATURE_LABEL).map((f) => {
          const v = stats.features[f] || { openai: 0, claude: 0 };
          const tot = v.openai + v.claude;
          return (
            <div key={f} className="flex items-center gap-3 text-xs">
              <span className="w-40 text-muted-foreground shrink-0">{FEATURE_LABEL[f]}</span>
              <div className="flex-1 h-2 rounded-full overflow-hidden bg-muted flex">
                {tot > 0 && <><span style={{ width: `${(v.openai / tot) * 100}%`, background: COLORS.openai }} /><span style={{ width: `${(v.claude / tot) * 100}%`, background: COLORS.claude }} /></>}
              </div>
              <span className="font-mono w-14 text-right text-muted-foreground">{v.openai}/{v.claude}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
